/// <amd-module name="Search/Shared/Components/LoadMore/LoadMore" />
import * as React from "react";
import * as SharedResources from "Search/Shared/Resources";
import { Spinner } from "VSSUI/Spinner";
import { LoadMoreProps } from "./LoadMore.Props";

export class LoadMore extends React.PureComponent<LoadMoreProps> {
    public render(): JSX.Element {
        return (
            <>
                {
                    this.props.error 
                    ? <div>{SharedResources.LoadMoreErrorMessage}</div>
                    : <Spinner className="search-results-load-more-spinner" label={SharedResources.FetchingResultsLabel} />
                }
            </>
        );
    }
}